export const NETWORK_TYPES = {
  csfd: 'CSFD',
  imdb: 'IMDB',
  letterboxd: 'Letterboxd',
}
